import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import parse from 'html-react-parser';
import { setPageClass, setUpHeader } from "../../store/features/slice-ui";
import { fetchVisitedDoctors } from "../../store/features/slice-doctors";
import { useBasePath } from "../../helpers/customHooks";
import Section from "../../components/Section";
import PageHead from "../../components/PageHead";
import PageContent from "../../components/PageContent";
import DoctorCard from "../../components/Cards/Doctor";
import ScrollToTop from '../../components/ScrollToTop';

const VisitedDoctorsList = () => {
  const dispatch = useDispatch();
  const basePath = useBasePath();
  let section = null;
  let pageTitle = null;
  switch (basePath) {
      case '/doctors/recently-viewed': 
          section = 'doctors';
          pageTitle = 'Find a Doctor';
      break;
      case '/discuss-patient/recently-viewed': 
          section = 'dp';
          pageTitle = 'Discuss a Patient';
      break;
      case '/refer-patient/recently-viewed': 
          section = 'rp';
          pageTitle = 'Refer a Patient';
      break;
      default: 
          section = 'doctors';
          pageTitle = 'Find a Doctor';
  }
  const doctorsIDs = useSelector((state) => state.doctors.visited);
  const doctorsListBasic = useSelector((state) => state.doctors.basic);
  const accountData = useSelector((state) => state.account.data);

  useEffect(() => {
    dispatch(setPageClass("page-doctor-viewed"));
    dispatch(setUpHeader({
      show:true,
      back: true,
      profile: true,
      search: true
    }));
  }, [dispatch]);

  useEffect(() => {
    if((!doctorsIDs)){
      dispatch(fetchVisitedDoctors());
    }
  }, [dispatch, doctorsIDs]);


  const renderDoctorsCards = () => {
    let link = '/doctor';
    switch(section){
      case 'doctors': link = '/doctor';
      break;
      case 'dp': link = '/doctor';
      break;
      case 'rp' : link = '/refer-patient/doctor';
      break;
      default: link = '/doctor'
    }
    return doctorsIDs && doctorsListBasic ? doctorsIDs.map(id => (
      doctorsListBasic[id] ?
        <DoctorCard
          key={id}
          slug={doctorsListBasic[id].slug}
          image={doctorsListBasic[id].profileImage}
          title={parse(doctorsListBasic[id].salutation+" "+doctorsListBasic[id].name)}
          subtitle={doctorsListBasic[id].tags && doctorsListBasic[id].tags.length > 0 ? doctorsListBasic[id].tags.map((tag, index) => index > 0 ? ', '+tag.name : tag.name)  : null}
          icon="chevron_right"
          centres={doctorsListBasic[id].centres}
          link={`${link}/${id}`}
          isFavourite = {accountData && accountData.favourites.includes(doctorsListBasic[id].slug) ? true : false}
      />
      : null
    )) : null;
  };

  return (
    <>
    <ScrollToTop />
    <PageHead 
      className="page-doctor-viewed--page-head"
      title={pageTitle}
      subtitle={'Recently viewed'}
    />
    <PageContent className="page-doctor-viewed--content">
    {doctorsIDs && doctorsIDs.length > 0 ? 
      <Section className="page-doctor-viewed--content-list">
        {renderDoctorsCards()}
      </Section> 
    : null}
    </PageContent>
    </> 
  );
};

export default VisitedDoctorsList;
